import { get, canUseDOM } from './index';
export var getCountryFromContext = function getCountryFromContext() {
  if (canUseDOM) {
    return get(window, 'current_country', 'IN');
  }
};